import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'merchant', data),
  get: (merchantId) => Ajax('get', `merchant/${merchantId}`),
  add: (data) => Ajax('post', 'merchant', data),
  edit: (merchantId, data) => Ajax('put', `merchant/${merchantId}`, data),
  delete: (merchantId) => Ajax('delete', `merchant/${merchantId}`),
  modifyStatus: (merchantId, isEnable) => Ajax('put', `merchant/enable/${merchantId}?isEnable=${isEnable}`),
};
